<template lang="pug">
  div
    modal-change-status(:concept="selectedConcept" :isVisible="isModalChangeStatusVisible" @closeModal="closeModalChangeStatus" :is-add='isModalAdd' @submit="updateStatus")
    modal-concepts(:form='selectedConcept', :is-add='isModalConceptsAdd' :isVisible="isModalConceptsVisible" @closeModal="closeModalConcepts")
    div.header_style
      div.dashboard_title
        h2 {{ $t('strings.pending_expenses') }}
        img.title_icon(src="@/assets/pin.png")
    div
    div.statistics
      div.statistic
        div.side_color(style="background-color: #1cb7ff")
        span.statistic_text {{ $t('dashboard.balance')}}
        strong.statistic_number {{ balance.pending_charges | currency }}
    br
    h3 {{ $t('dashboard.pending_expenses') }}
    br
    vm-table.table(max-height="350px" :data="concepts")
      template(slot="thead")
        vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('concepts.' + column) }}
      template(slot-scope="{data}")
        vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
          vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
            slot(v-if="column == 'date'")  {{ concepts[indextr][column] | moment("DD MMMM YYYY").toUpperCase() }}
            slot(v-if="column == 'charge' || column == 'payment'")  {{concepts[indextr][column] | currency }}
            slot(v-if="column !== 'status' && column !== 'conceptable_name' && column !== 'date' && column !== 'charge' && column !== 'conceptable_type'") {{ concepts[indextr][column] }}
            slot(v-if="column == 'conceptable_type'")  {{data[indextr][column] === 'App\\Models\\AdministrativeConcept' ? $t('dashboard.administrative') : data[indextr][column] == 'App\\Models\\Project' ? $t('dashboard.project') : $t('dashboard.supplier')}}
            slot(v-if="column == 'conceptable_name'")  {{concepts[indextr]['conceptable']['name']}}
            vm-status-indicator(v-if="column == 'status'" :pulse="true" :color="statusColor(concepts[indextr][column])") {{ concepts[indextr][column] === 1 ? $t('dashboard.payed') : $t('dashboard.invoiced') }}
          vm-td
          vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
            vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
            vm-dropdown-menu(style="width: 12rem")
              vm-dropdown-item.d-flex.justify-content-between(@click="showModalChangeStatus(concepts[indextr])")
                vm-icon(icon="checkmark-circle-outline")
                slot &nbsp;{{ $t('strings.change_status') }}
              vm-dropdown-item.d-flex.justify-content-between(@click="updateConcept(concepts[indextr], tr)")
                vm-icon(icon="edit-2-outline")
                slot &nbsp;{{ $t('strings.edit') }}
              vm-dropdown-item.d-flex.justify-content-between(@click="deleteConceptConfirm(concepts[indextr])")
                vm-icon(icon="trash-2-outline")
                slot &nbsp;{{ $t('strings.delete') }}
    vm-pagination.pagination(
    :total="conceptsPagination.totalPages",
    v-model="currentPage",
    goto)
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
import moment from 'moment'
const { mapGetters, mapActions } = createNamespacedHelpers('Dashboard')
const ModalConcepts = () => import('@/components/modals/ModalConcepts.vue')
const ModalChangeStatus = () => import('@/components/modals/ModalChangeConceptStatus.vue')

export default {
  components: {
    ModalConcepts,
    ModalChangeStatus
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    currentPage: 1,
    date: '',
    form: {
      date: moment().format('YYYY-MM-DD'),
      conceptable_type: '',
      conceptable_id: '',
      concept: '',
      payment: 0,
      charge: 0,
      status: 1
    },
    columns: ['date', 'conceptable_type', 'conceptable_name', 'concept', 'charge', 'status'],
    isModalConceptsVisible: false,
    isModalConceptsAdd: true,
    isModalChangeStatusVisible: false,
    selectedConcept: {},

    attributeModal: 'concept'
  }),
  computed: {
    ...mapGetters([
      'concepts',
      'conceptsPagination',
      'monthlyStatistic',
      'filterParams',
      'balance'
    ])
  },
  watch: {
    async currentPage (value) {
      this.loadConcepts({ page: value })
    }
  },
  async created () {
    this.filters = {
      byYear: null,
      byMonth: null,
      where: {
        status: '=2',
        charge: '!=0'
      }
    }
    this.applyFilter(this.filters)
    await this.loadConcepts({ page: this.currentPage })
    await this.loadBalance()
  },
  methods: {
    ...mapActions([
      'deleteRecord',
      'loadConcepts',
      'applyFilter',
      'loadBalance',
      'editConcept'
    ]),
    statusColor (status) {
      return status === 1 ? 'success' : 'warning'
    },
    showModalChangeStatus (concept) {
      this.isModalAdd = false
      this.selectedConcept = { ...concept }
      this.isModalChangeStatusVisible = true
    },
    async closeModalChangeStatus () {
      this.isModalChangeStatusVisible = false
      this.form = {}
      this.loadBalance()
      setTimeout(async () => {
        await this.loadConcepts({ page: this.currentPage })
      }, 200)
    },
    updateStatus (form) {
      this.editConcept({ ...this.selectedConcept, ...form })
    },
    async deleteConceptConfirm (record) {
      let t = this
      this.auxDeleteRecord = async () => {
        await t.deleteRecord({ ...record, route: 'concepts', type: 'CONCEPT' }).then(() => {
          t.selected = []
        })
        await t.loadBalance()
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation2', {
          model: this.$t('strings.concept'),
          attribute: this.$t(record[this.attributeModal])
        }),
        accept: this.auxDeleteRecord
      })
    },
    updateConcept (concept) {
      this.selectedConcept = { ...concept, payment: parseFloat(concept.payment).toFixed(2), charge: parseFloat(concept.charge).toFixed(2) }
      this.isModalConceptsAdd = false
      this.isModalConceptsVisible = true
    },
    async closeModalConcepts () {
      this.isModalConceptsVisible = false
      this.form = {
        date: moment().format('YYYY-MM-DD'),
        conceptable_type: '',
        conceptable_id: '',
        concept: '',
        payment: 0,
        charge: 0,
        status: ''
      }
      await this.loadBalance()
    }
  }
}
</script>
<style scoped lang="scss">
@import './dashboard_structure.css';
</style>
